export function getQueryValue(key: string) {
	const urlParams = new URLSearchParams(window.location.search);
	const value = urlParams.get(key);
	return value;
}
export function setQueryValue(valueRecord: Record<string, string> | null) {
	if (valueRecord === null) {
		const url = new URL(window.location.href);
		url.search = "";
		window.history.replaceState({}, "", url.toString());
		return;
	}
	const newParams = new URLSearchParams(valueRecord);
	const value = newParams.toString();
	window.history.pushState({}, "", "?" + value);
}